import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@business/workflows/ComponentUI/IconButton';
import { SVGAssets } from '@business/assets/vectors';
import { MediaPostHeaderProps } from '@business/interfaces/photo';

const MediaPostHeader: React.FC<MediaPostHeaderProps> = ({
  onBack,
  onExpand,
  onShare,
  onZoomIn,
  onZoomOut,
  onInfo,
  onStar,
  onDelete,
  onDownload,
  mediaType,
  isFavorite
}) => {
  const { t } = useTranslation();

  return (
    <header className="flex items-center justify-between px-6 py-4 max-w-6xl mx-auto">
      {/* Back button */}
      <IconButton label={t('mediaView.back')} onClick={onBack}>
        <SVGAssets.BackIcon className="w-5 h-5 text-white" />
      </IconButton>

      {/* Action buttons */}
      <div className="flex items-center gap-3 text-gray-200">
        <IconButton label={t('mediaView.expand')} onClick={onExpand}>
          <SVGAssets.Expand className="w-5 h-5 text-white" />
        </IconButton>
        <IconButton label={t('mediaView.share')} onClick={onShare}>
          <SVGAssets.Share className="w-4 h-4" />
        </IconButton>

        {/* Zoom buttons - only for images */}
        {mediaType === 'image' && (
          <>
            <IconButton label={t('mediaView.zoomIn')} onClick={onZoomIn}>
              <SVGAssets.ZoomIn className="w-4 h-4" />
            </IconButton>
            <IconButton label={t('mediaView.zoomOut')} onClick={onZoomOut}>
              <SVGAssets.ZoomOut className="w-5 h-5" />
            </IconButton>
          </>
        )}

        <IconButton label={t('mediaView.info')} onClick={onInfo}>
          <SVGAssets.Info className="w-4 h-4" />
        </IconButton>
        <IconButton label={t('mediaView.favorite')} onClick={onStar}>
          {isFavorite ? (
            <SVGAssets.Favorite className="w-4 h-4 " />
          ) : (
            <SVGAssets.FavoriteIcons className="w-4 h-4 " />
          )}
        </IconButton>
        <IconButton label={t('mediaView.delete')} onClick={onDelete}>
          <SVGAssets.DeleteIcon className="w-4 h-4" />
        </IconButton>
        <IconButton label={t('mediaView.download')} onClick={onDownload}>
          <SVGAssets.DownloadIcon className="w-5 h-5" />
        </IconButton>
      </div>
    </header>
  );
};

export default MediaPostHeader;
